<template>
  <div>
    <el-form ref="postForm" class="" :model="postForm" label-width="110px" :rules="rules">  

      <el-form-item :label="$t('changepwd.oldpwd')" prop="oldpwd">
        <el-input :placeholder="$t('changepwd.tipoldpwd')" v-model="postForm.oldpwd" type="password" autocomplete="off"
                  style="width:260px;">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('changepwd.newpwd')" prop="newpwd">
        <el-input :placeholder="$t('changepwd.tipnewpwd')" v-model="postForm.newpwd" type="password" autocomplete="off"
                  style="width:260px;">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('changepwd.renewpwd')" prop="renewpwd">
        <el-input :placeholder="$t('changepwd.tiprenewpwd')" v-model="postForm.renewpwd" type="password" autocomplete="off"
                  style="width:260px;">
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('changepwd.pwdstrong')">
        <div id="tips">
          <span :class="pwdstrong==0? 's1':''">弱</span>
          <span :class="pwdstrong==1? 's2':''">中</span>
          <span :class="pwdstrong==2? 's3':''">强</span>
          <span :class="pwdstrong==3? 's4':''">很强</span>
        </div>
      </el-form-item> 
    </el-form>
    <el-row class="form-btn">
      <el-button :loading="loading.submit" type="primary" @click="onSubmit">{{$t('table.submit')}}</el-button>
    </el-row>
  </div>
</template>
<script>
  import {changePwd} from '@/api/base/sysuser'
  import {notify, checkPassWord} from '@/utils'
  import {validateEnter} from '@/utils/validate' 

  export default {
    name: 'changepwd', 
    data() {
      var validatePwd = (rule, value, callback) => {
        if (value === '' || value === null) {
          callback(new Error('请输入密码'));
        } else {
          if (this.postForm.renewpwd !== '') {
            this.$refs.postForm.validateField('renewpwd');
          }
          callback();
        }
      };
      var validateRePwd = (rule, value, callback) => {
        if (value === '' || value === null) {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.postForm.newpwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        loading: {submit: false},
        pwdstrong: 0,
        timer: null,
        delaytime: 0,
        encodeGetCode: false,
        postForm: {
          oldpwd: '',
          renewpwd: '',
          newpwd: '',
          userpwdstrong: '',
        },
        rules: {
          oldpwd: [{required: true, validator: validatePwd, trigger: ['blur', 'change']}],
          newpwd: [{required: true, validator: validatePwd, trigger: ['blur', 'change']}],
          renewpwd: [{required: true, validator: validateRePwd, trigger: ['blur', 'change']}]
        }
      }
    },
    methods: {
      onSubmit() {
        this.$refs.postForm.validate(valid => {
          if (valid) {
            let data = {newpwd: this.postForm.newpwd, oldpwd: this.postForm.oldpwd} 
            changePwd(data).then(response => {
              notify('修改成功', () => {
                this.$emit("update:showdialog", false)
              });
            })
          } else {
            return false
          }
        })
      }, 
    },
    watch: {
      'postForm.newpwd'(curVal, oldVal) {
        this.pwdstrong = checkPassWord(curVal)
      }, 
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  @import "~@/styles/mixin.scss";

  #tips {
    float: left;
    font-size: 12px;
    width: 400px;
    height: 25px;
    margin: 4px 0 0 0px;
  }

  #tips span {
    float: left;
    width: 40px;
    height: 20px;
    color: #fff;
    overflow: hidden;
    margin-right: 10px;
    background: #D7D9DD;
    line-height: 20px;
    text-align: center;
  }

  #tips .s1 {
    background: #F45A68;
  }

  /*红色*/
  #tips .s2 {
    background: #fc0;
  }

  /*橙色*/
  #tips .s3 {
    background: #cc0;
  }

  /*黄色*/
  #tips .s4 {
    background: #14B12F;
  }

  /*绿色*/

</style>



// WEBPACK FOOTER //
// src/views/layout/components/ChangePwd.vue